import Layout from "../components/Layout";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { useSelector } from "react-redux";
import { Fragment } from "react";
import { Toast } from "primereact/toast";
import { confirm } from "react-bootstrap-confirmation";

const EmployeeTaskList = () => {
    const primeToast = useRef(null);
    const [empList, setEmpList] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const { user } = useSelector((state) => state["auth"]);
    const [isLoading, setIsLoading] = useState(false);
    const [quater, setQuater] = useState([])

    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        getQuarterActiveList();
        getTaskList(user.registerID, user.quarterID);
    }, [])

    const [formObject, setFormObject] = useState({
        activity: "",
        quarterID: user.quarterID,
        registerID: user.registerID,
        sl: user.registerID
    });

    const getTaskList = async (id, quarterID) => {
        console.log("getTaskList");
        const data = {
            RegisterID: id,
            QuarterID: parseInt(quarterID)
        }
        setIsLoading(true);
        await axios.post(BASE_URL + "/api/employeetasklist/GetEmployeeTaskList", JSON.stringify(data))
            .then(response => {
                console.log("Hello");
                console.log(JSON.stringify(response.data));
                setTableData(response.data);
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                console.log(error);
            });
    }

    const onValChange = (event) => {
        setFormObject((res) => ({
            ...res,
            [event.target.name]: event.target.value,
        }));
    };
    const onFormSubmit = (event) => {
        event.preventDefault();
        const checkVal = !Object.values(formObject).every((res) => res === "");
        if (checkVal) {
            setTableData((data) => [...data, formObject]);
            const isEmpty = { activity: "", quarterID: user.quarterID, registerID: user.registerID, sl: user.registerID };
            setFormObject(isEmpty);
        }
    };

    const onFormSave = async (event) => {
        event.preventDefault();
        console.log(JSON.stringify(tableData));

        if (tableData.length === 0) {
            //show toast please complete all assessment
            primeToast.current.show({
                severity: 'error',
                summary: 'error',
                detail: 'Please add task by clicking Add button.',
                life: 3000
            });
            return;
        }
        await axios.post(BASE_URL + '/api/employeetasklist/SaveEmployeeTaskList', tableData)
            .then((response) => {
                if (response.status === 200) {
                    console.log("Save success!!");
                    getTaskList(user.registerID, user.quarterID);
                    primeToast.current.show({
                        severity: "success",
                        summary: "success",
                        detail: "Task Save Successfully",
                        life: 3000,
                    });
                }
            });
    };

    const childToParent = () => {
        getQuarterList(user.registerID, document.getElementById('ddlQuarter').value);
    }

    const getQuarterList = (id, quarterID) => {
        const data = {
            RegisterID: id,
            QuarterID: parseInt(quarterID)
        }
        setIsLoading(true);
        axios.post(BASE_URL + "/api/utility/SupervisedUsersInformation", JSON.stringify(data))
            .then(response => {
                setEmpList(response.data)
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                console.log(error);
            });
    }

    const getQuarterActiveList = () => {
        axios.get(BASE_URL + "/api/quarter/GetActiveList")
            .then(response => {
                setQuater(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const onDataDelete = async (index, sl) => {
        const result = await confirm('Are you really sure?');
        if (result === true) {
            setTableData((data) => data.filter((_, i) => i !== index));

            if (sl && sl !== user.registerID) {
                await axios.post(BASE_URL + "/api/employeetasklist/DeleteEmployeeTaskList/" + sl)
                    .then((response) => {
                        if (response.status === 200) {
                            primeToast.current.show({
                                severity: "success",
                                summary: "success",
                                detail: "Task Deleted Successfully",
                                life: 3000,
                            });
                        }
                    });
            }
        };
    };

    function Table({ tableData }) {
        return (
            <table className="table">
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Task</th>
                        <th hidden={true}>ID</th>
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                                <td hidden={true}>{data.sl}</td>
                                <td className="text-center">
                                    <button
                                        type="button"
                                        onClick={() => onDataDelete(index, data.sl)}
                                        className="btn btn-danger"
                                    >Delete</button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    function Form({ onValChange, formObject, onFormSubmit }) {
        return (
            <div className="row mb-4">
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Task"
                        onChange={onValChange}
                        autoFocus="autoFocus"
                        value={formObject.activity}
                        name="activity"
                    />
                </div>
                <div className="d-grid">
                    <button
                        type="button"
                        onClick={onFormSubmit}
                        className="btn btn-warning"
                    >Add</button>
                </div>
            </div>
        );
    }

    return (<Layout>
        <Toast ref={primeToast} />
        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i className="bi bi-people-fill"></i> Task List</h6>

                {/* <div className="col-md-4">                    
                    <QuarterNames childToParent={childToParent} />
                </div> */}

                <div className="col-md-4" style={{ textAlign: 'right' }}>
                    <b>Quarter:</b> {quater.length !== 0 && quater[0].quarterName}/{new Date().getFullYear()}
                </div>
            </div>
            <div className="card-body">
                <div className="row g-3 mb-1 align-items-center">
                    <div className="col-md-8">
                        <Fragment>
                            <Form
                                onValChange={onValChange}
                                formObject={formObject}
                                onFormSubmit={onFormSubmit}
                            />

                            <Table tableData={tableData} />

                            <div className="col-md-12 text-end">
                                <button
                                    type="button"
                                    onClick={onFormSave}
                                    className="btn btn-success"
                                >Save</button>
                            </div>

                        </Fragment>
                    </div>
                </div>
            </div>
        </div>

    </Layout>)
}
export default EmployeeTaskList